import { render } from "./form5.vue?vue&type=template&id=6c7d7b2c&scoped=true&ts=true"
import script from "./form5.vue?vue&type=script&lang=ts"
export * from "./form5.vue?vue&type=script&lang=ts"

import "./form5.vue?vue&type=style&index=0&id=6c7d7b2c&lang=less&scoped=true"

import exportComponent from "../../../../node_modules/.store/vue-loader@17.4.2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6c7d7b2c"]])

export default __exports__